export default {
  /**
   * 微信应用
   */
  wechat: {
    appName: '应用名称将作为微信公众号打开网页标题',
    businessMode: '(1)普通模式：按照现有流程，用户付现金然后分账到云诊。<br>' +
      '(2)企业点数模式：用户自行充值或平台为企业充值点数，用户将企业点数划分给团队队长，团队内部用户检测时直接扣除对应团队队长点数。',
    checkPaymentMode: '未配置：检测报告页不展示支付入口<br>' +
      '免费：用户无须支付，可以直接查看检测报告<br>' +
      '服务商商户：客户需要向平台申请微信支付特约商户，然后通过授权给平台，检测报告页支付入口将使用此微信支付特约商户<br>' +
      '普通商户：客户自行配置普通商户开发参数，检测报告页支付入口将使用此普通商户',
    dueAmountTotal: '检测报告页面显示需要支付的金额',
    paidAmountTotal: '订单金额-免充值代金券金额。如果不使用免充值代金券则等于订单金额',
    settleAmountTotal: '根据配置的结算费率，预估微信平台会扣多少手续费',
    profitSharingTotal: '订单分账给其他用户金额',
    profitSharingCount: '共计有多少比订单分账失败，一个月内系统会自动重新尝试分账。',
    incomeAmountTotal: '应结金额 + 打赏金额 - 预估手续费 - 打赏预估手续费 - 分账金额',
    gratuityAmountTotal: '含义同订单金额',
    gratuityPaidAmountTotal: '含义同应结金额',
    gratuitySettleAmountTotal: '含义同预估手续费',
    topDiseaseClassification: '当前应用适用的检测类别，控制用户使用时可选择的检测类别。',
    profitSharingTipForCommon: '开启分账前，请在微信普通商户端开通“分账”产品',
    profitSharingTipForSp: '开启分账前，请联系平台开通“分账”权限'
  },
  /**
   * h5应用
   */
  h5app: {
    chargeType: '1、平台收费：按公众号收费业务收费，支持团队业务<br>' +
      '2、免费：可以直接看检测报告，无收费操作<br>' +
      '3、企业收费：只能使用微信支付且金额是指定值<br>' +
      '4、企业点数：使用企业点数完成检测<br>' +
      '5、企业用户无法自行修改收费方式，需联系云诊管理员',
    memberInterfaceRecharge: '1、用户点数充值API开关打开时，支持企业使用接口为个人用户充值点数<br>' +
      '2、用户点数充值API开关打开时且平台收费-个人点数支付成功时，向个人点数支付成功回调地址返回消耗点数的数据',
    topDiseaseClassification: '当前应用适用的检测类别，控制用户使用时可选择的检测类别。'
  },
  apiapp: {
    list: {
      create: {
        devIdAndDevSecret: '用于获取API调用授权使用的access_token，应用ID(devId)在应用创建时自动生成。',
        returnUrl: 'API调用时，如果出现检测结果接收回调地址(returnUrl)为空的情况，平台会使用此处配置的应用回调地址。',
        topDiseaseClassification: '当前应用适用的检测类别，API调用传参“检测类别编码”需属于该应用适用的检测类别。'
      },
      detail: {
        devIdAndDevSecret: [
          '1、应用ID(devId)和应用秘钥(devSecret)',
          '用于获取API调用授权使用的access_token。',
          'devId在应用创建时自动生成；',
          'devSecret为6-20位数字或大小写字母。'
        ],
        returnUrl: [
          '2、回调地址',
          'API调用时，如果出现检测结果接收回调地址(returnUrl)为空的情况，平台会使用此处配置的应用回调地址。'
        ],
        aesKey: [
          '3、应用AES秘钥(aesKey)',
          '用于API调用传参时，对年龄和性别或问诊回答数据进行加密；',
          '平台接收到调用请求时，会用其对请求数据进行解密，解密失败会返回失败提示。'
        ],
        devRsa: [
          '4、应用RSA密钥对',
          '用于API调用传参时对第三方单据流水号(outId)的签名和验签；',
          '应用RSA私钥(devRsaPrivateKey)平台不会保存，用户在API调用传参时，对outId进行签名；',
          '当用户遗忘应用RSA私钥时，可点击“重置”按钮生成新的应用RSA密钥对，请妥善保管应用RSA私钥；',
          '平台接收到调用请求时，会使用应用RSA公钥(devRsaPublicKey)对其进行验签，验签失败会返回失败提示。'
        ],
        rsa: [
          '5、平台RSA密钥对',
          '用于检测结果回调时对第三方单据流水号(outId)的签名和验签；',
          '平台进行回调时，会使用平台RSA私钥(rsaPrivateKey)对outId进行签名；',
          '用户接收到回调请求时，请使用平台RSA公钥(rsaPublicKey)对其进行验签，以判断结果的合法性。'
        ],
        topDiseaseClassification: [
          '6、适用的检测类别',
          '当前应用适用的检测类别，API调用传参“检测类别编码”需属于该应用适用的检测类别。'
        ]
      }
    }
  },
  userManage: {
    userType: '主账号：该用户可以访问系统所有功能，包括微信应用、API应用、H5应用、企业认证、用户管理、费用中心等页面。<br>子账号：该用户只能访问部分微信应用，以及企业信息和个人账户信息等页面。'
  }
}



// WEBPACK FOOTER //
// ./src/help/index.js